import { BRAND } from "../constants/brand";

const SOCIAL = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/labarium",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/labarium",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="5"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
];

export default function Footer({ setPage }) {
  const go = (route) => { setPage(route); window.scrollTo({ top: 0, behavior: "smooth" }); };

  const linkStyle = {
    fontFamily: "'Inter', sans-serif",
    fontSize: 13, fontWeight: 400,
    color: "rgba(255,255,255,0.5)",
    marginBottom: 11, cursor: "pointer",
    display: "flex", alignItems: "center", gap: 7,
    transition: "all 0.2s ease",
    textDecoration: "none",
  };
  const linkHover = (e, on) => {
    e.currentTarget.style.color = on ? BRAND.gold : "rgba(255,255,255,0.5)";
    e.currentTarget.style.paddingLeft = on ? "4px" : "0";
  };

  return (
    <footer style={{ background: BRAND.navyDeep, color: BRAND.white }}>
      {/* Gold accent top */}
      <div style={{ height: 2, background: `linear-gradient(90deg, transparent 0%, ${BRAND.gold} 30%, ${BRAND.goldLight} 50%, ${BRAND.gold} 70%, transparent 100%)` }} />

      {/* Main grid */}
      <div className="footer-grid rx-pad" style={{ maxWidth: 1400, margin: "0 auto", padding: "72px 40px 52px", display: "grid", gridTemplateColumns: "2.4fr 1fr 1fr 1fr 1fr", gap: 48 }}>

        {/* Brand column */}
        <div>
          <div style={{ marginBottom: 24 }}>
            <img src="/logo-full-dark.png" alt="Labarium Diagnostic Systems" style={{ height: 44, width: "auto", display: "block", filter: "brightness(1.05)" }} />
          </div>

          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.85, maxWidth: 280, marginBottom: 24, fontWeight: 400 }}>
            The Healthcare Decision Company. Building next-generation clinical laboratory infrastructure with AI-powered diagnostic insights.
          </p>

          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.45)", lineHeight: 2, fontWeight: 400 }}>
            <div style={{ color: BRAND.gold, fontWeight: 600, letterSpacing: "0.12em", fontSize: 10, textTransform: "uppercase", marginBottom: 8 }}>Contact</div>
            {/* Georgia address hidden — now Labarium Affiliated Laboratory, not under Diagnostic Systems
            <div>100 Industrial Park Drive</div>
            <div>Milledgeville, Georgia 31061</div>
            */}
            <div>495 Grand Blvd #206</div>
            <div>Miramar Beach, Florida 32550</div>
            <div style={{ marginTop: 8 }}>(850) 460-1484</div>
            <div>Toll-Free: (877) 765-2274</div>

            <div style={{ marginTop: 4 }}>info@labarium.com</div>
            <div style={{ marginTop: 4, color: "rgba(255,255,255,0.35)" }}>Mon–Fri: 8:00 AM – 5:30 PM</div>
          </div>

          {/* Social icons */}
          <div style={{ display: "flex", gap: 10, marginTop: 24 }}>
            {SOCIAL.map(s => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                title={s.label}
                style={{
                  width: 36, height: 36, borderRadius: 10,
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "rgba(255,255,255,0.4)",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = "rgba(201,169,110,0.5)";
                  e.currentTarget.style.color = BRAND.gold;
                  e.currentTarget.style.background = "rgba(201,169,110,0.08)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.color = "rgba(255,255,255,0.4)";
                  e.currentTarget.style.background = "transparent";
                }}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Company */}
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 20, textTransform: "uppercase" }}>Company</div>
          {[
            { label: "About Us", route: "about-us" },
            { label: "Leadership Team", route: "leadership-team" },
            { label: "Careers", route: "careers" },
            { label: "Newsroom", route: "newsroom" },
            // { label: "Licenses", route: "licenses" },
            { label: "Join Our Lab Network", route: "lab-acquisitions" },
          ].map(item => (
            <div
              key={item.route}
              onClick={() => go(item.route)}
              style={linkStyle}
              onMouseEnter={e => linkHover(e, true)}
              onMouseLeave={e => linkHover(e, false)}
            >
              <span style={{ width: 4, height: 4, borderRadius: "50%", background: BRAND.gold, opacity: 0.5, flexShrink: 0 }} />
              {item.label}
            </div>
          ))}
        </div>

        {/* Providers */}
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 20, textTransform: "uppercase" }}>Providers</div>
          {["Billing and Coding", "Insurance", "Logistics", "Medical Necessity", /* "Portal Access", */ "Test Index", "Annual Notice"].map(item => (
            <div
              key={item}
              onClick={() => go(item.toLowerCase().replace(/ /g, "-"))}
              style={linkStyle}
              onMouseEnter={e => linkHover(e, true)}
              onMouseLeave={e => linkHover(e, false)}
            >
              <span style={{ width: 4, height: 4, borderRadius: "50%", background: BRAND.gold, opacity: 0.5, flexShrink: 0 }} />
              {item}
            </div>
          ))}
        </div>

        {/* Patients */}
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 20, textTransform: "uppercase" }}>Patients</div>
          {[
            { label: "Find Patient Results", route: "find-patient-results" },
            { label: "Insurance",            route: "patient-insurance" },
            { label: "Make an Appointment",  route: "make-an-appointment" },
            // { label: "Patient Billing",      route: "patient-billing" },
          ].map(item => (
            <div
              key={item.route}
              onClick={() => go(item.route)}
              style={linkStyle}
              onMouseEnter={e => linkHover(e, true)}
              onMouseLeave={e => linkHover(e, false)}
            >
              <span style={{ width: 4, height: 4, borderRadius: "50%", background: BRAND.gold, opacity: 0.5, flexShrink: 0 }} />
              {item.label}
            </div>
          ))}

          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, margin: "24px 0 16px", textTransform: "uppercase" }}>Portals</div>
          {[
            { label: "Labarium AI", href: "https://portal.labarium.com" },
            // { label: "Employee Login", href: "https://mllaborchard.netsmartcloud.com/" },
            // { label: "Pay Online", href: "https://patient.xifin.net/peportal/pages/login/?cn=medlake&tn=medlake#/login" },
          ].map(item => (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              style={linkStyle}
              onMouseEnter={e => linkHover(e, true)}
              onMouseLeave={e => linkHover(e, false)}
            >
              <span style={{ width: 4, height: 4, borderRadius: "50%", background: BRAND.gold, opacity: 0.5, flexShrink: 0 }} />
              {item.label}
            </a>
          ))}
        </div>

        {/* Hours + Legal */}
        <div>
          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 20, textTransform: "uppercase" }}>Hours</div>

          <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 10, padding: "16px 16px", marginBottom: 20 }}>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.6)", marginBottom: 3 }}>Customer Service</div>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.35)" }}>Mon–Fri: 8:00 AM – 5:30 PM</div>
            {/* Draw Station hours hidden
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.6)", marginBottom: 3 }}>Draw Station</div>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.35)" }}>Mon–Fri: 8:30 AM – 3:45 PM</div>
            */}
          </div>

          <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 10, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 14, textTransform: "uppercase" }}>Legal</div>
          {[
            { label: "PHI Privacy Notice", route: "phi-privacy-notice" },
            { label: "Website Privacy Policy", route: "website-privacy-policy" },
            { label: "Terms of Use", route: "terms-of-use" },
            { label: "Accessibility", route: "accessibility" },
          ].map(item => (
            <div
              key={item.label}
              onClick={() => go(item.route)}
              style={{ ...linkStyle, fontSize: 12, color: "rgba(255,255,255,0.35)" }}
              onMouseEnter={e => { e.currentTarget.style.color = BRAND.gold; }}
              onMouseLeave={e => { e.currentTarget.style.color = "rgba(255,255,255,0.35)"; }}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="rx-pad" style={{ maxWidth: 1400, margin: "0 auto", padding: "20px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.25)", letterSpacing: "0.04em", fontWeight: 400 }}>
            © 2026 Labarium Diagnostic Systems, Inc. All rights reserved.
          </div>
          <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 12, color: BRAND.gold, letterSpacing: "0.06em", fontStyle: "italic", opacity: 0.7 }}>
            In Hoc Signo Vinces — Better information. Better decisions. Better lives.
          </div>
        </div>
      </div>
    </footer>
  );
}
